import {
  UseMutationResult,
  useQueryClient,
  useMutation,
} from '@tanstack/react-query';
import { axiosInstance } from 'hooks/auth/AxiosInstance';

export interface DriverFormData {
  firstName: string;
  lastName: string;
  regNo: string;
  phoneNumber: string;
}

const addDriver = async (data: DriverFormData) => {
  const response = await axiosInstance.post(
    'payment/saveVehicleOwnerDetails',
    data,
  );
  return response.data;
};

const useAddDriver = (): UseMutationResult<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  Error,
  DriverFormData
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addDriver,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['driver'] });
      queryClient.invalidateQueries({ queryKey: ['drivers'] });
    },
    onError: (error: Error) => {
      console.error('Error adding driver:', error.message);
    },
  });
};

export default useAddDriver;
